import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Domain\Org\Http\Controllers\AuthController::acknowledge
* @see app/Domain/Org/Http/Controllers/AuthController.php:141
* @route '//org.launchstation.app/auth/recovery-codes/acknowledge'
*/
export const acknowledge = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: acknowledge.url(options),
    method: 'post',
})

acknowledge.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/auth/recovery-codes/acknowledge',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::acknowledge
* @see app/Domain/Org/Http/Controllers/AuthController.php:141
* @route '//org.launchstation.app/auth/recovery-codes/acknowledge'
*/
acknowledge.url = (options?: RouteQueryOptions) => {
    return acknowledge.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::acknowledge
* @see app/Domain/Org/Http/Controllers/AuthController.php:141
* @route '//org.launchstation.app/auth/recovery-codes/acknowledge'
*/
acknowledge.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: acknowledge.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::acknowledge
* @see app/Domain/Org/Http/Controllers/AuthController.php:141
* @route '//org.launchstation.app/auth/recovery-codes/acknowledge'
*/
const acknowledgeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: acknowledge.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::acknowledge
* @see app/Domain/Org/Http/Controllers/AuthController.php:141
* @route '//org.launchstation.app/auth/recovery-codes/acknowledge'
*/
acknowledgeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: acknowledge.url(options),
    method: 'post',
})

acknowledge.form = acknowledgeForm

const recovery = {
    acknowledge: Object.assign(acknowledge, acknowledge),
}

export default recovery